<div class="grid">
  <div class="product-overview__header col-12 col-6--md col-4--sm" [class.loading]="loading" #header>
    <air-title *ngIf="content.title" [title]="content.title" [region]="region" [isFirst]="isFirst"></air-title>
    <div class="d--none d--block--md">
      <div class="button button--border button--filter" (click)="onFilterButtonClick()">
        <span>{{ "product.filter.label.filter" | translate }}</span>
        <i class="icon icon-ui-filter"></i>
        <div class="button__badge" *ngIf="filtersActive"></div>
      </div>
    </div>
    <div class="product-overview__sorter">
      <div
        class="product-overview__sorter--label"
        [internalInnerHtml]="('product.sorter.sort_0_items_by' | translate).format([filteredProducts.length])"
      ></div>
      <form [formGroup]="sorterForm" class="form" *ngIf="sorterForm">
        <div class="form-group">
          <select formControlName="sortBy" class="form-control" (change)="sortProducts()">
            <option *ngFor="let option of sorterOptions" [value]="option.value" [selected]="option.selected">
              {{ option.text }}
            </option>
          </select>
          <i class="icon icon-ui-arrow--down"></i>
        </div>
      </form>
    </div>
  </div>

  <ng-container *ngIf="products && !loading; else loadingBlock">
    <div class="col-3 d--none--md">
      <air-product-filter
        *ngIf="!loading"
        [initialFilters]="filters"
        [filteredSubcategories]="filteredSubcategories"
        [initialFilteredPartners]="initialFilteredPartners"
        [filteredPartners]="filteredPartners"
        [rangeCeiling]="rangeCeiling"
        (filterChange)="applyFilters($event)"
      ></air-product-filter>
    </div>
    <div class="col-9 col-6--md col-4--sm col-start-4 col-start-1--md">
      <ng-container *ngIf="filteredProducts">
        <ul class="product-list" *ngIf="filteredProducts.length > 0; else empty">
          <li
            *ngFor="let p of filteredProducts | paginate: { itemsPerPage: itemsPerPage, currentPage: page }"
            class="product-list__item col-3 col-4--sm"
          >
            <air-product-card
              [product]="p.product"
              [userEventSource]="userEventSource"
              [userEventObject]="p.userEventObject"
            ></air-product-card>
          </li>
        </ul>
        <pagination-controls
          *ngIf="filteredProducts.length > itemsPerPage"
          class="pagination"
          [directionLinks]="false"
          [autoHide]="true"
          (pageChange)="onPageChange($event)"
        ></pagination-controls>
      </ng-container>
    </div>
  </ng-container>
</div>

<ng-template #loadingBlock>
  <div class="col-3 d--none--md">
    <air-product-filter></air-product-filter>
  </div>
  <div class="col-9 col-6--md col-4--sm col-start-4 col-start-1--md">
    <ul class="product-list">
      <li *ngFor="let product of [] | range: itemsPerPage" class="product-list__item col-3 col-4--sm">
        <air-skeleton-card [additionalClasses]="{ 'card--product': true }"></air-skeleton-card>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #empty>
  <div class="product-list--empty">
    <h3>{{ "product.overview.no_products_found" | translate }}</h3>
    <p>{{ "product.overview.modify_your_filters" | translate }}</p>
  </div>
</ng-template>
